<script>

    import {get} from "svelte/store";
    import {publishConfigStore} from "../core/app-store.js";
    import {cartTotalStore} from "../cart/cart-store.js";
    import {onDestroy, onMount} from "svelte";
    import {additionalCostsStore, deliveryStore, removeAdditionalCost} from "./../orders/orders-store.js";
    import {getTotals} from "./../orders/orders.js";
    import { t } from '../core/i18n/language-store';

    export let hideTotal = false;
    export let hideDelivery = false;

    const publishConfig = get(publishConfigStore);

    let currency = publishConfig.currency ? ` ${publishConfig.currency}` : '';

    let itemsPrice;
    let deliveryPrice;
    let totalPrice;

    const storeSubscriptions = [
        deliveryStore.subscribe(() => {calculateFinalPrice();}),
        cartTotalStore.subscribe(() => {calculateFinalPrice();})
    ];

    function calculateFinalPrice () {

        const totals = getTotals();

        itemsPrice = totals.itemsPrice;
        deliveryPrice = totals.deliveryPrice;
        totalPrice = totals.totalPrice;
    }

    function removeAdditionalCostHandler (idx) {
        removeAdditionalCost(idx);
        calculateFinalPrice();
    }

    onMount(() => {
        calculateFinalPrice();
    });

    onDestroy(() => {
        for (let i = 0; i < storeSubscriptions.length; i++){
            storeSubscriptions[i]();
        }
    });

</script>

<style>

    ul {
        display: flex;
        flex-direction: column;
        gap: .75rem;
    }
    li {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .total-label {
        font-size: 20px;
        color: var(--main-font-color);
        font-weight: 500;
    }
    .total-value {
        padding-left: .5em;
        font-size: 16px;
        color: var(--accent-color);
        font-weight: 500;
    }
    .remove-add-cost-button {
        width: 1.5rem;
        height: 1.5rem;
        background: var(--accent-color-semi);
        color: var(--accent-color);
        border: none;
        border-radius: 50%;
        font-family: inherit;
        font-size: inherit;
        font-weight: 400;
    }

    .final-label,
    .final-value {
        font-size: 24px;
        color: var(--accent-color);
        font-weight: 800;
    }

    .final-label,
    .total-label {
        font-family: Roboto Condensed, sans-serif;
        text-transform: uppercase;
    }
    .final-value,
    .total-value {
        font-family: PT Mono, sans-serif;
        text-transform: uppercase;
    }

</style>

<div>

    {#if (itemsPrice || deliveryPrice || totalPrice)}
        <ul>

            {#if (itemsPrice)}
                <li>
                    <div class="total-label">{$t('blocks.total.sum')}</div>
                    <div class="total-value nowrap">{itemsPrice} {currency}</div>
                </li>
            {/if}

            {#each $additionalCostsStore.items as item, idx}
                <li>
                    <div class="total-label wrap-anywhere">{item.name}</div>

                    {#if item.removable}
                        <div class="flex ai-center gap-05">
                            <div class="total-value nowrap">{item.cost} {currency}</div>
                            <button class="remove-add-cost-button pointer" on:click={() => removeAdditionalCostHandler(idx)}>×</button>
                        </div>
                    {:else}
                        <div class="total-value nowrap">{item.cost} {currency}</div>
                    {/if}
                </li>
            {/each}

            {#if (deliveryPrice && !hideDelivery)}
                <li>
                    <div class="total-label">{$t('blocks.total.delivery')}</div>
                    <div class="total-value nowrap">{deliveryPrice} {currency}</div>
                </li>
            {/if}

            {#if (totalPrice && !hideTotal)}
                <li class="final">
                    <div class="final-label">{$t('blocks.total.total')}</div>
                    <div class="final-value nowrap">{totalPrice} {currency}</div>
                </li>
            {/if}

        </ul>
    {/if}

</div>
